import ComponentModule from "@eisinc/Overrides/Components/ProductQuantityBreakPricing";

export * from "@eisinc/Overrides/Components/ProductQuantityBreakPricing";

export default ComponentModule;
